import React from 'react';
import variableLanguage from '../../utils/hookGetVariablesLanguage';
const Error404 = () => {
    const variable_38 = variableLanguage({keyPage: 'landing', keyVariable: 'variable_38'})
    return (
        <div className="block_404">
            <div className="img">
            <span>{variable_38}</span>
            </div>
        </div>
    );
};

export default Error404;